<template>
    <div>
        <h2>Sub Services</h2>
        <ElDivider/>

        <el-tabs type="border-card" v-model="activeIndex">
            <el-tab-pane :label="item.serviceName" v-for="(item,index) in serviceList" :key="index">
            </el-tab-pane>

            <transition name="move" mode="out-in">
                <router-view></router-view>
            </transition>
        </el-tabs>
    </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
    import {listServiceByPid} from '@/api/HomeserviceApi'

    export default {
        name: 'Service',
        data: function () {
            return {
                activeIndex: '0',
                serviceList: [],
                fistTimeLoaded: true
            }
        },
        methods: {
            loadService() {
                listServiceByPid(0).then(res => {
                    this.serviceList = res.data
                    if (this.fistTimeLoaded) {
                        // 如果是第一次加载该页面，则自动进行一次子页面渲染
                        this.fistTimeLoaded = !this.fistTimeLoaded
                        this.changePage(0)
                    }
                })
            },
            changePage(val) {
                let service = this.serviceList[val]
                if (service.subType === 2) {
                    this.$router.push('/eazable/services/service/RepairService/' + this.serviceList[val].id)
                } else if (service.subType === 0) {
                    this.$router.push('/eazable/services/service/CommService/' + this.serviceList[val].id)
                }
            }
        },
        watch: {
            'activeIndex': function (val) {
                this.changePage(val)
            }
        },
        mounted() {
            this.loadService()
        }
    }
</script>

<style scoped>

</style>
